import { render } from "./CoBrandGilt.vue?vue&type=template&id=c11d39fa&scoped=true"
import script from "./CoBrandGilt.vue?vue&type=script&lang=js"
export * from "./CoBrandGilt.vue?vue&type=script&lang=js"

import "./CoBrandGilt.vue?vue&type=style&index=0&id=c11d39fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11d39fa"]])

export default __exports__